let edsApiInstance = null
export function installEdsApi(ref) {
  if (edsApiInstance === null) {
    edsApiInstance = new EdsApi(ref)
  }
}

export function getEdsApiInstance() {
  return edsApiInstance
}

class EdsApi {
  #ref = null
  constructor(ref) {
    this.#ref = ref
  }

  /**
   * Подписать файл
   * @param file объект вида { fileUrl: "https://...." }
   * @returns {Promise<*>}
   */
  async signFile(file, innerSign = false) {
    return await this.#ref.signFile(file, innerSign)
  }

  /**
   * Подписать строку
   * @param data String
   * @returns {Promise<*>}
   */
  async signData(data, innerSign = false) {
    return await this.#ref.signFile(data, innerSign)
  }
}